import {
  buildPath,
  buildTemplatePath,
  Grid,
  Page,
  PageRoute,
  useParams,
  Stack,
  GridBreak,
  Box,
  newToast,
  Typography,
  buildOptionalParams,
} from "@compass/core";
import {
  Application,
  ApplicationQuestion,
  ApplicationQuestionResponse,
  ApplicationResponse,
  ApplicationSection,
  PublicApplicationResponseDto,
  PublicApplicationViewResource,
} from "generated/openApi";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ApiService from "services/apiService";
import { createEntity } from "utils/CreateEntity";
import produce from "immer";
import { setAppToast } from "redux/reducers/appSlice";
import { PublicApplicationTitle } from "./PublicApplicationTitle";
import { PublicApplicationSubmission } from "./PublicApplicationSubmission";
import { PublicApplicationQuestionPage } from "./PublicApplicationQuestionPage";
import { TransientFormAnswer, TransientQuestionResponse, responseHasAnswer } from "../common/TransientQuestionResponse";

const routeName = "application";

class Params {
  id: string = "";
  client: string = "demo";
}

class OptionalParams {
  reviewGuid?: string | undefined = undefined;
}

export const publicApplicationPageRoute: PageRoute<Params, OptionalParams> = {
  handle: "application",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
  getOptionalParams: (params) => buildOptionalParams(params),
};

export const PublicApplicationPage = () => {
  const { params, optionalParams } = useParams(routeName, Params, OptionalParams);
  const [viewResource, setViewResource] = useState<PublicApplicationViewResource>({} as PublicApplicationViewResource);
  const dispatch = useDispatch();

  const [validationErrors, setValidationErrors] = useState<object>();
  const [transientQuestionResponses, setTransientQuestionResponses] = useState<TransientQuestionResponse[]>([]);
  const [application, setApplication] = useState<Application>({} as Application);
  const [applicationReview, setApplicationReview] = useState<ApplicationResponse>();
  const [beginApplication, setBeginApplication] = useState<boolean>();
  const [showSubmissionPage, setShowSubmissionPage] = useState<boolean>();
  const [centerLogoUrl, setCenterLogoUrl] = useState<string>();
  const [leftLogoUrl, setLeftLogoUrl] = useState<string>();
  const [rightLogoUrl, setRightLogoUrl] = useState<string>();

  // for branching v2
  const [hasBranches, setHasBranches] = useState<boolean>(false);
  const [activeQuestions, setActiveQuestions] = useState<ApplicationQuestion[]>([]);
  // const [activeSections, setActiveSections] = useState<ApplicationSection[]>([]);

  const isViewMode = false;

  useEffect(() => {
    getApplication();
    fetchViewResource();
  }, []);

  useEffect(() => {
    if (hasBranches) {
      initializeApplicationQuestions();
    }
    else {
      if (application && application.applicationSections) {
        setActiveQuestions(application.applicationSections.flatMap(x => x.applicationQuestions!));
      }
    }
  }, [transientQuestionResponses]);

  const initializeApplicationQuestions = () => {
    if (!hasBranches) {

    }
    else {
      // set up initial active questions (i.e questions with no branchedFromFormAnswer or branchedFromFormQuestion)
      var hasNext: boolean = true;
      var activeQuestions: ApplicationQuestion[] = [];
      var activeSections: ApplicationSection[] = [];

      // set up initial
      application?.applicationSections?.flatMap(x => x.applicationQuestions).forEach((q) => {
        if (q &&!questionIsBranched(q)) {
          activeQuestions.push(q);
        }
      });
      // survey?.formSections?.forEach((s) => {
      //   if (!sectionIsBranched(s)) {
      //     activeSections.push(s);
      //   }
      // });

      while (hasNext) {
        // handle questions first
        var nextActiveQuestions = findActiveBranchedQuestions(activeQuestions);

        // if no new active questions
        if (nextActiveQuestions == activeQuestions) {
          hasNext = false;
        }
        else {
          // otherwise mark them as active
          if (nextActiveQuestions != activeQuestions) {
            activeQuestions = activeQuestions.concat(nextActiveQuestions);
          }
        }

        const temp: ApplicationQuestion[] = [];
        activeQuestions.map((n) => {
          const parentQuestionIds = findParentQuestionIds(n);
          var branchIndex = temp.findIndex((t) => parentQuestionIds.some((p) => p == t.id));
          if (branchIndex != - 1) {
            temp.splice(branchIndex + 1, 0, n);
          }
          else {
            temp.push(n);
          }
        })
        activeQuestions = temp;

        // handle sections after we find active questions
        // if (survey?.formSections && activeQuestions.some(q => q.branchToFormSectionId != null)) {
        //   activeSections = survey?.formSections?.filter(s => activeQuestions.some(q => q.branchToFormSectionId == s.id));
        // }
      }

      setActiveQuestions(activeQuestions);

      // reset non-active questions
      // transientQuestionResponses.filter(t => !activeQuestions.some(a => a.id == t.questionId)).map((t) => {
      //   t.writeIn = null,
      //   t.formAnswers = [],
      //   t.signatureFile = null,
      //   t.writeInDate = null,
      //   t.writeInDecimal = null
      // });
      // let tempTransientQuestions: TransientQuestionResponse[] = transientQuestionResponses.filter(t => activeQuestions.some(a => a.id == t.questionId));
      // console.log("temp", tempTransientQuestions);
      // console.log("temp2", transientQuestionResponses);
    

      // setActiveSections(activeSections);

      // set up pages
      // let pageCount: number = 1;

      // let sectionCount: number = 0;

      // let activePages: PublicSurveyPageDto[] = [];
      // let startingPage: PublicSurveyPageDto = createBlankPage(pageCount);
      // activePages.push(startingPage);

      // let tempCurrentPage = startingPage;
      // activeQuestions.forEach((q) => {
      //   if (!q.startNewPage) {
      //     tempCurrentPage.sections![sectionCount].questions?.push(q);

      //     if (q.branchToFormSectionId) {
      //       var mappedSection = survey?.formSections?.find((f) => f.id == q.branchToFormSectionId);

      //       let newSection: PublicSurveySectionDto = {
      //         section: mappedSection,
      //         questions: []
      //       };
      //       tempCurrentPage.sections?.push(newSection);
      //       sectionCount++;
      //     }
      //   }
      //   else {
      //     pageCount = pageCount + 1;
      //     sectionCount = 0;
      //     var nextPage = createBlankPage(pageCount);
      //     tempCurrentPage = nextPage;
      //     tempCurrentPage.sections![sectionCount].questions?.push(q);
      //     activePages.push(tempCurrentPage);
      //   }
      // })

      // let findCurrentPage = activePages.find(p => p.pageNumber == pageIndex);

      // if (JSON.stringify(tempTransientQuestions) != JSON.stringify(transientQuestionResponses)) {
      //   setTransientQuestionResponses(tempTransientQuestions!);
      // }
      // if (JSON.stringify(activePages) != JSON.stringify(surveyPages)) {
      //   setSurveyPages(activePages);
      // }
      // setMaxPageIndex(pageCount);
    }
  }

  const findParentQuestionIds = (question: ApplicationQuestion) : number[] => {
    const parentQuestionIds: number[] = [];
    if (question.branchedFromApplicationQuestionIds && question.branchedFromApplicationQuestionIds.length > 0) {
      question.branchedFromApplicationQuestionIds!.map((q) => {
        parentQuestionIds.push(q);
      })
    }
    if (question.branchedFromApplicationAnswerIds && question.branchedFromApplicationAnswerIds.length > 0) {
      question.branchedFromApplicationAnswerIds!.map((a) => {
        const applicationQuestion = application?.applicationSections?.flatMap(x => x.applicationQuestions).find(q => q && q.applicationAnswers?.some((fa) => fa.id == a));
        parentQuestionIds.push(applicationQuestion!.id);
      })
    }
    return parentQuestionIds;
  }

  const questionIsBranched = (question: ApplicationQuestion) : boolean => {
    if ((question.branchedFromApplicationAnswerIds != null && question.branchedFromApplicationAnswerIds.length > 0) ||
    (question.branchedFromApplicationQuestionIds != null && question.branchedFromApplicationQuestionIds.length > 0) ||
    (question.branchedFromApplicationSectionIds != null && question.branchedFromApplicationSectionIds.length > 0))
      return true;
    else return false;
  }

  const findActiveBranchedQuestions = (activeQuestions: ApplicationQuestion[]): ApplicationQuestion[] => {
    var nextActiveQuestions: ApplicationQuestion[] = [];
    var activeQuestionIds = activeQuestions.flatMap(q => q.id);
    var activeFormAnswerIds: number[] = [];

    transientQuestionResponses.forEach((t) => {
      var answers = t.formAnswers.flatMap(x => x.formAnswerId);
      var newAnswers = answers.filter(a => a && !activeFormAnswerIds.includes(a));
      if (newAnswers.length > 0) {
        activeFormAnswerIds = activeFormAnswerIds.concat(newAnswers as number[]);
      }
    })

    var branchingQuestions = application?.applicationSections?.flatMap(x => x.applicationQuestions).filter(q => questionIsBranched(q!));

    if (!branchingQuestions || branchingQuestions.length == 0) {
      return activeQuestions;
    }

    branchingQuestions.forEach((q) => {
      // check for branching question
      if (q && q.branchedFromApplicationQuestionIds?.some(b => activeQuestionIds.includes(b))) {
        if (!activeQuestionIds.includes(q.id)) {
          nextActiveQuestions.push(q);
        }
      }

      // check for branching answers
      if (q && q.branchedFromApplicationAnswerIds != null && q.branchedFromApplicationAnswerIds.length > 0) {
        if (activeFormAnswerIds.some(a => q.branchedFromApplicationAnswerIds?.some(b => b.toString() == a.toString()))) {
          if (!activeQuestionIds.includes(q.id)) {
            nextActiveQuestions.push(q);
          }
        }
      }
    })

    if (nextActiveQuestions.length > 0) {
      return nextActiveQuestions;
    }

    return activeQuestions;
  }

  // setup transient question responses
  useEffect(() => {
    const transientQuestionResponses: TransientQuestionResponse[] = [];

    application?.applicationSections?.map((s) => {
      s.applicationQuestions?.map((q) => {
        transientQuestionResponses.push({
          questionId: q.id,
          writeIn: q.defaultAnswer || null,
          writeInDate: null,
          writeInDecimal: null,
          formAnswers: [],
          signatureFile: null,
          fileUpload: null,
        });
      });
    });

    if (optionalParams.reviewGuid != null && optionalParams.reviewGuid.length > 0 && !applicationReview)
    {
      ApiService.publicApplication.getApplicationResponse(optionalParams.reviewGuid, params.client).then((response) => {
        response?.applicationQuestionResponses?.forEach((r) => {
          var mappedResponse = transientQuestionResponses.find((t) => t.questionId == r.applicationQuestionId);
          if (mappedResponse) {
            if (r.applicationAnswerId != null || r.applicationPropertyEntityId) {
              var applicationAnswer: TransientFormAnswer = {
                formAnswerId: r.applicationAnswerId,
                formEntityId: r.applicationPropertyEntityId,
                subQuestionId: r.applicationSubQuestionId,
                writeIn: r.writeIn,
              };
              mappedResponse?.formAnswers.push(applicationAnswer);
            } else {
              mappedResponse.writeIn = r.writeIn || null;
              mappedResponse.writeInDate = r.writeInDate != null ? formatDate(r.writeInDate) : null;
              mappedResponse.fileUpload = r.fileUploadFile || null
            }
          }
        });
        setApplicationReview(response);
        setBeginApplication(true);
      })
    }

    setTransientQuestionResponses(transientQuestionResponses);
  }, [application]);

  const formatDate = (newDate) => {
    var date = new Date(newDate);
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Get month (adding 1 since January is 0-indexed), pad with leading zero if necessary
    const day = date.getDate().toString().padStart(2, '0'); // Get day of the month, pad with leading zero if necessary
    const year = date.getFullYear(); // Get full year
    return `${month}/${day}/${year}`; // Return formatted string
  }

  const navigateChildApplication = () => {
    ApiService.publicApplication.getApplication(viewResource!.childApplicationGuid, params.client).then((response) => {
      setApplication(response.application!);
      setHasBranches(response.hasBranches);
      if (response.application!.leftLogoBase64) {
        setLeftLogoUrl(response.application!.leftLogoBase64);
      }
      if (response.application!.centerLogoBase64) {
        setCenterLogoUrl(response.application!.centerLogoBase64);
      }
      if (response.application!.rightLogoBase64) {
        setRightLogoUrl(response.application!.rightLogoBase64);
      }

      ApiService.publicApplication.getApplicationViewResource(response.application!.guid, params.client).then((r2) => {
        setViewResource(r2);
      });
    });
  };

  const navigateParentApplication = () => {
    ApiService.publicApplication.getApplication(viewResource!.parentApplicationGuid, params.client).then((response) => {
      setApplication(response.application!);
      setHasBranches(response.hasBranches);
      if (response.application!.leftLogoBase64) {
        setLeftLogoUrl(response.application!.leftLogoBase64);
      }
      if (response.application!.centerLogoBase64) {
        setCenterLogoUrl(response.application!.centerLogoBase64);
      }
      if (response.application!.rightLogoBase64) {
        setRightLogoUrl(response.application!.rightLogoBase64);
      }
      ApiService.publicApplication.getApplicationViewResource(response.application!.guid, params.client).then((r2) => {
        setViewResource(r2);
      });
    });
  };

  // useEffect(() => {
  //   const erroredQuestions: number[] = [];
  //   // Get all errors
  //   for (const error in validationErrors) {
  //     const questionId: number = parseInt(error.replace("questionId", ""));
  //     erroredQuestions.push(questionId);
  //   }

  //   if (!erroredQuestions.length)
  //     return;

  //   let firstErroredQuestionId: number | null = null;

  //   console.log("errored questions", erroredQuestions);

  //   // find first error's page
  //   application?.applicationSections?.forEach((section) => {
  //     section.applicationQuestions?.forEach((question) => {
  //       if (firstErroredQuestionId == null) {
  //         if (firstErroredQuestionId == null && erroredQuestions.includes(question.id)) {
  //           firstErroredQuestionId = question.id;

  //           console.log("section", section);
  //           console.log("section", question);

  //           const element = document.getElementById(`questionId${question.id}`);
  //           if (element) {
  //             element.scrollIntoView(true);
  //           }
  //         }
  //       }
  //     })
  //   })
  // }, [validationErrors]);

  const updateTransientResponse = (questionResponse: TransientQuestionResponse) => {
    setTransientQuestionResponses(
      produce((draft) => {
        let draftQuestionResponseIndex = draft.findIndex((q) => q.questionId == questionResponse.questionId);

        draft[draftQuestionResponseIndex] = questionResponse;
      })
    );
  };

  const getApplication = () => {
    ApiService.publicApplication.getApplication(params.id, params.client).then((response) => {
      setApplication(response.application!);
      setHasBranches(response.hasBranches);
      if (response.application!.leftLogoBase64) {
        setLeftLogoUrl(response.application!.leftLogoBase64);
      }
      if (response.application!.centerLogoBase64) {
        setCenterLogoUrl(response.application!.centerLogoBase64);
      }
      if (response.application!.rightLogoBase64) {
        setRightLogoUrl(response.application!.rightLogoBase64);
      }
    });
  };

  const fetchViewResource = () => {
    ApiService.publicApplication.getApplicationViewResource(params.id, params.client).then((response) => {
      setViewResource(response);
    });
  };

    // if any questions are marked "MarkedForReview", enable Reviewer workflow
    const canSendToReviewer = (): boolean => {
      application.applicationSections?.map((s) => {
        s.applicationQuestions?.map((q) => {
          if (q.markedForReview) return true;
        })
      })
      return false;
    }

  const submitResponse = (applicationResponse: PublicApplicationResponseDto) => {
    // convert transient -> form response
    const formQuestionResponses: ApplicationQuestionResponse[] = [];

    transientQuestionResponses.map((transient) => {
      // only add in transient responses that have an actual answer
      if (responseHasAnswer(transient)) {
        // if form question has answers (i.e. multiple choice, matrix, etx)
        if (transient.formAnswers.length > 0) {
          transient.formAnswers.forEach((answer) => {
            const questionResponse: ApplicationQuestionResponse = createEntity<ApplicationQuestionResponse>({
              applicationQuestionId: transient.questionId,
              applicationAnswerId: answer.formAnswerId != 0 ? answer.formAnswerId : null,
              applicationPropertyEntityId: answer.formEntityId,
              applicationSubQuestionId: answer.subQuestionId,
              writeIn: answer.writeIn,
              signatureFile: null,
            });

            formQuestionResponses.push(questionResponse);
          });
        } else {
          const questionResponse: ApplicationQuestionResponse = createEntity<ApplicationQuestionResponse>({
            applicationQuestionId: transient.questionId,
            writeIn: transient.writeIn,
            writeInDate: transient.writeInDate,
            signatureUploadData: transient.signatureFile,
            fileUploadFile: transient.fileUpload
          });
          formQuestionResponses.push(questionResponse);
        }
      }
    });

    applicationResponse.applicationQuestionResponses = formQuestionResponses;

    if (optionalParams.reviewGuid != null && optionalParams.reviewGuid.length > 0) {
      applicationResponse.isReviewer = true;
    }

    if (optionalParams != null && optionalParams.reviewGuid != null)
    {
      applicationResponse.isReviewer = true;
      applicationResponse.applicationResponseGuid = optionalParams.reviewGuid;
      ApiService.publicApplication
      .updateApplicationResponse(applicationResponse, params.client)
      .then((response) => {
        setShowSubmissionPage(true);
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        setValidationErrors(ex.data);
      });
    }
    else {
      ApiService.publicApplication
      .saveApplicationResponse(applicationResponse, params.client)
      .then((response) => {
        setShowSubmissionPage(true);
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        setValidationErrors(ex.data);
      });
    }
  };

  const startApplication = () => {
    setBeginApplication(true);
  };

  return (
    <Page>
      {application && (
        <Grid container spacing="lg" style={{ padding: "50px" }}>
          <Grid item md={4} xs={4} style={{ display: "flex", justifyContent: "center", padding: 0 }}>
            {leftLogoUrl && <img src={leftLogoUrl} style={{ maxWidth: "100%", maxHeight: 250 }} />}
          </Grid>
          <Grid item md={4} xs={4} style={{ display: "flex", justifyContent: "center", padding: 0 }}>
            {centerLogoUrl && <img src={centerLogoUrl} style={{ maxWidth: "100%", maxHeight: 250 }} />}
          </Grid>
          <Grid item md={4} xs={4} style={{ display: "flex", justifyContent: "center", padding: 0 }}>
            {rightLogoUrl && <img src={rightLogoUrl} style={{ maxWidth: "100%", maxHeight: 250 }} />}
          </Grid>

          <GridBreak />
          <Grid item xs={12}>
            <Stack alignItems="center" justifyContent="center" height="100%">
              <Box sx={{ minWidth:"420px", maxWidth: "1000px", width: "100%" }}>
                {application && !beginApplication && (
                  <PublicApplicationTitle
                    application={application}
                    beginApplication={() => startApplication()}
                    navigateChildApplication={navigateChildApplication}
                    navigateParentApplication={navigateParentApplication}
                  />
                )}
                {showSubmissionPage && <PublicApplicationSubmission application={application} />}
                {application && viewResource && !showSubmissionPage && beginApplication && (
                  <PublicApplicationQuestionPage
                    isViewMode={false}
                    activeQuestions={activeQuestions}
                    isReviewMode={optionalParams != null && optionalParams.reviewGuid != null}
                    application={application}
                    applicationResponse={applicationReview}
                    viewResource={viewResource}
                    transientQuestionResponses={transientQuestionResponses}
                    updateQuestionResponse={updateTransientResponse}
                    submitResponse={submitResponse}
                    validationErrors={validationErrors}
                  />
                )}
              </Box>
            </Stack>
          </Grid>
        </Grid>
      )}
      <Box position="relative" bottom={20} zIndex={100} textAlign="center" >
        <Typography variant="caption">
          <>Copyright © 2006-{new Date().getFullYear()} Cobro Consulting. All Rights Reserved.</>
        </Typography>
      </Box>
    </Page>
  );
};
